<template>
  <div class="min-h-screen">
    <SiteHeader :page-name="'Report Customization'" />
    <div class="mt-4 w-full m-auto">
      <Toolbar pt:root:class="mx-4 py-2">
        <template #start>
          <div class="flex flex-col">
            <Select :options="reports" optionLabel="name" v-model="selectedReport" class="w-144" scrollHeight="40rem"></Select>
          </div>
        </template>
      </Toolbar>
      <div v-if="selectedReport != null">
        <ReportCustomization :report="selectedReport"></ReportCustomization>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { type ReportData, ListOfReportDataSchema } from "@/types/Reports";

const route = useRoute();
const reports = ref<ReportData[]>([]);
const selectedReport = ref<ReportData>();

onMounted(async (): Promise<void> => {
  axios
    .get("/reports/list/ALL_REPORTS?only_editable=true")
    .then((response) =>
      handleApiResponse(
        response,
        (data: any) => {
          reports.value = ListOfReportDataSchema.parse(data).reports;
          if (route.params.reportId != null) {
            reports.value.forEach((report) => {
              if (report.id === route.params.reportId) {
                selectedReport.value = report;
              }
            });
          }
          if (selectedReport.value == null) selectedReport.value = reports.value[0];
        },
        (errors: ApiError[]) => {
          error("An error occurred", errors[0].message);
        }
      )
    )
    .catch((e) => errorApi(e));
});
</script>
